<div class="popup-container" *ngIf="showError">
    <div class="popup-model" [ngClass]="getPopupClass()">
        <div class="popup-header">
            <div class="popup-header-text">{{headerTitle}}</div>
            <div class="popup-close" (click)="close()" title="Close"></div>
        </div>
        <div class="popup-body">
            <div class="message-block" [ngStyle]="{ display: customcss(messageText), height: heightValue }">
                {{messageText}}
            </div>
        </div>
        <div class="popup-footer" *ngIf="!isConfirmMode && alertType !== 'error' && !hideOkButton">
            <div class="popup-btn" (click)="onOkBtnClick()">
                <div class="btn-text">{{buttonText}}</div>
            </div>
        </div>
        <div class="popup-footer" *ngIf="isConfirmMode">
            <div class="popup-btn confirm" (click)="handleConfirm()">
                <div class="btn-text">{{confirmText}}</div>
            </div>
            <div class="popup-btn cancel" *ngIf="cancelText" (click)="handleCancel()">
              <div class="btn-text">{{cancelText}}</div>
            </div>
        </div>
    </div>
</div>